type PackItemAttributes =
  | ({ trait_type: string } & (
      | { display_type: string; value: number }
      | { value: string }
    ))[];

export const getPackContent = (attributes: PackItemAttributes) => {
  if (!attributes) {
    return {
      packGrenades: [],
      packPerks: [],
      packWeapons: [],
    };
  }
  const weapons = attributes
    .filter((attr) => attr.trait_type === 'Skins Included (Weapons)')
    .map((weapon) => {
      const [weaponName, skinName] = weapon.value.split(' - ');
      return { name: weaponName.toLowerCase(), skin: skinName.toLowerCase() };
    });
  return {
    packGrenades: [],
    packPerks: [],
    packItems: weapons,
  };
};
